import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-userbox',
  templateUrl: './sidebar-userbox.component.html'
})
export class SidebarUserboxComponent {}
